export function TechnicalSessionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.75 18.992v2.258H15a.75.75 0 010 1.5H9a.75.75 0 110-1.5h2.25v-2.258h1.5z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M2 6a4 4 0 014-4h12a4 4 0 014 4v9a4 4 0 01-4 4H6a4 4 0 01-4-4V6z"
        opacity="0.4"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        fill="currentColor"
        transform="matrix(1 0 0 -1 10 10)"
      />
      <rect width="8" height="4" x="8" y="11" fill="currentColor" rx="2" />
    </svg>
  );
}
